import React from 'react';
import { useTranslation } from 'react-i18next';
import ConversationItem from './ConversationItem';

const ConversationsList = ({ 
    conversations, 
    activeConversationId,
    activeDropdownId,
    onNewChat,
    onSelectConversation,
    onMenuClick
}) => {
    const { t } = useTranslation();

    return (
        <div className="conversations-list" id="conversationsList">
            <div className='d-flex flex-column w-100 justify-content-around mb-2'>
                <span 
                    className="new-chat-action" 
                    onClick={onNewChat}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            onNewChat();
                        }
                    }}
                    style={{ cursor: 'pointer' }}
                >
                    <i className="bi bi-plus-circle"></i> {t('chat.sidebar_new_chat', 'New chat')}
                </span>
            </div>
            
            <div className="mb-3">
                <span className='conversation-cont-title'>
                    <i className="bi bi-clock-history"></i> {t('chat.sidebar_recents', 'Recents')}
                </span>
            </div>
            
            {conversations.length === 0 ? (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                    <span className="empty-chats-notification">
                        {t('chat.sidebar_no_conversation', 'No conversations yet')}
                    </span>
                </div>
            ) : (
                conversations.map((conv) => (
                    <ConversationItem
                        key={conv.timestamp}
                        conversation={conv}
                        isActive={conv.conversation_id === activeConversationId}
                        hasActiveDropdown={activeDropdownId === conv.timestamp}
                        onSelect={onSelectConversation}
                        onMenuClick={onMenuClick}
                    />
                ))
            )}
        </div>
    );
};

export default React.memo(ConversationsList);